import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
// Asumsi path dan komponen LogoGMIM, Menu, X, dan styling sudah benar
import { LogoGMIM } from "../../../assets";
import { LogOut, User } from "lucide-react";
import "./navbarLogin.scss";
import backEndDataContext from "../../../contexts/backendDataContexts";

// --- Data Placeholder (Ganti dengan data auth sesungguhnya) ---

// -------------------------------------------------------------

const NavBarLogin = () => {
  const backEndData = useContext(backEndDataContext);
  const navigate = useNavigate();

  // Fungsi yang meniru proses Logout
  const handleLogout = () => {
    // Di aplikasi nyata: panggil fungsi logout dari auth service (e.g., Firebase, Auth0)

    // Setelah logout berhasil, arahkan ke halaman utama (Home)
    navigate("/login");
  };

  const handleNavigateLogo = () => {
    const role = backEndData.getUserDetails().role.toLowerCase();
    let dashboardPath = "/"; // Default ke home

    if (role === "admin") {
      dashboardPath = "/admin";
    } else if (role === "operator") {
      dashboardPath = "/operator";
    }

    navigate(dashboardPath);
  };

  // Jika Anda ingin menggunakan desain responsif, gunakan menuOpen,
  // tetapi untuk operator dashboard, seringkali menunya statis.
  // Untuk kesederhanaan dan fokus pada permintaan, kita hilangkan semua menu item
  // dan hanya menyisakan info user dan tombol logout.

  return (
    <div className="navbar-wrap">
      {/* 1. Logo dan Nama Jemaat (Kiri Pojok) */}
      {/*buatkan kondisi route sesuai role yang login, jika user role admin maka ketika klik logo gmim dia akan route /admin kalau dia operator akan route /operator*/}
      <div className="logo-wrap" onClick={() => handleNavigateLogo()}>
        <img src={LogoGMIM} alt="Logo GMIM" className="logo" />
        <div className="text-wrap">
          <p className="title">Gereja Masehi Injili di Minahasa</p>
          <p className="subtitle">Jemaat Genesaret Pateten</p>
        </div>
      </div>

      {/* 2. Area Informasi User dan Aksi (Kanan) */}
      <div className="admin-menu-wrap">
        {/* Info User */}
        <div className="user-info">
          <User size={20} className="user-icon" />
          <div className="text-display">
            <p className="greeting">
              Hi, {backEndData.getUserDetails().firstName}{" "}
              {backEndData.getUserDetails().lastName}
            </p>
            <p className="role-status">{backEndData.getUserDetails().role}</p>
          </div>
        </div>

        {/* Tombol Logout */}
        <button className="logout-button" onClick={handleLogout}>
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>

      {/* Hamburger dihapus karena tidak ada menu item yang perlu disembunyikan */}
    </div>
  );
};

export default NavBarLogin;
